import React from 'react';
import styles from './PatientDot.module.css'
import { connect } from 'react-redux'

class PatientDot extends React.Component {
    render() {
        let color = this.props.dotColor ? this.props.dotColor.COLOR : 'transparent';
        let hover = this.props.dotColor ? this.props.dotColor.COLORNAME + ' - ' + this.props.dotColor.NAME : '';

        let cls;
        cls = styles.dot;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <div className={cls} style={{ backgroundColor: color, borderStyle: 'solid', borderWidth: '1px', borderColor: '#717271' }} title={hover} />
        );
    }
}


function mapStateToProps(state, ownprops) {
    return {
        dotColor: state.entities.masterData.DOTCOLORS ? state.entities.masterData.DOTCOLORS[ownprops.id] : undefined
    };
}

const connectedPatientDot = connect(mapStateToProps)(PatientDot);
export { connectedPatientDot as PatientDot };